import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, eyebrow, title, copy, align = "left", dark = false }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className={`flex items-center gap-3 text-xs font-mono uppercase tracking-[0.28em] ${align === "center" ? "justify-center" : ""} ${dark ? "text-champagne" : "text-teal/70"}`}>
        {index && <span className={dark ? "text-ivory/40" : "text-ink/30"}>{index}</span>}
        <span className={`inline-block h-px w-8 ${dark ? "bg-champagne/60" : "bg-champagne-dark"}`} aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-5 font-display text-3xl md:text-5xl font-light tracking-tight leading-[1.08] ${dark ? "text-ivory" : "text-ink"}`}>
        {title}
      </h2>
    </Reveal>
    {copy && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed font-light ${dark ? "text-ivory/70" : "text-ink/65"}`}>{copy}</p>
      </Reveal>
    )}
  </div>
);
